import type { DigitalTwinSettingTarget } from 'api/digitalTwin/digitalTwin.api'
import type { Event } from 'ui/components/BarCalendar/BarCalendar.types'
import { getSettingTarget } from 'ui/components/DigitalTwinSettingEditor/editorSetting.helper'
import {
  isBarOfSetting,
  levelAndNameToLookUpId,
} from './components/DigitalTwinSettingsCalendar/DigitalTwinSettingsCalendar.helper'
import type { SplitViewSelection } from './settingEditor.types'

/** The property the split view is open for; null for a new setting that has no property yet. */
function getSelectedProperty(selection: SplitViewSelection): DigitalTwinSettingTarget | null {
  return selection.kind === 'property' ? selection.property : getSettingTarget(selection.setting)
}

/** Whether a table row's property is the one the split view is open for. */
export function isSelectedProperty(
  property: Partial<DigitalTwinSettingTarget> | undefined,
  selection: SplitViewSelection
): boolean {
  const selected = getSelectedProperty(selection)
  return (
    !!selected &&
    property?.level === selected.level &&
    property.name === selected.name &&
    property.attribute === selected.attribute
  )
}

/**
 * Whether a calendar bar is what the split view is open for: the setting itself when one was opened,
 * otherwise every setting of the opened property.
 */
export function isSelectedCalendarEvent(event: Event, selection: SplitViewSelection): boolean {
  if (selection.kind === 'setting' && selection.setting.id !== undefined) {
    return isBarOfSetting(event, selection.setting)
  }
  const property = getSelectedProperty(selection)
  return (
    !!property &&
    event.categoryId === levelAndNameToLookUpId(property.level, property.name) &&
    event.attribute === property.attribute
  )
}
